export default {
    find: 'найдено | найден | найдено | найдено',
    results: 'результатов | результат | результата {count} | результатов',
    findResults: 'найдено {count} результатов | найден {count} результат | найдено {count} результата | найдено {count} результатов',
};
